<!--<div class="fixed inset-0 z-10 bg-neutral-950 mix-blend-multiply flex flex-col items-center justify-center">-->
<!--	<div class="w-full pt-12 border border-white bg-theme-950 text-white flex flex-col gap-4 bg-white/10">-->

<!--		<app-ui-logo></app-ui-logo>-->

<!--		<div class="font-decimaLight uppercase text-base leading-none flex justify-center">&nbsp;&nbsp;&nbsp;L&nbsp;&nbsp;&nbsp;O&nbsp;&nbsp;&nbsp;G&nbsp;&nbsp;&nbsp;R&nbsp;&nbsp;&nbsp;</div>-->


<!--		<div class="w-full flex-1 flex flex-col justify-center items-center p-8">-->
<!--			<input [(ngModel)]="svcAuth.clinicianEmail" class="auth-input" placeholder="Email" type="text"/>-->
<!--			<input [(ngModel)]="svcAuth.clinicianPword" class="auth-input" placeholder="Password" type="password"/>-->

<!--			<button (click)="svcAuth.signInWithEmailAndPassword()" class="auth-btn auth-btn-invert mt-2">-->
<!--				<span class="auth-btn-icon"><i class="fa-sharp fal fa-key"></i></span>-->
<!--				<span class="auth-btn-name">Authenticate Clinician</span>-->
<!--			</button>-->
<!--		</div>-->


<!--	</div>-->


<!--	<button (click)="svcAuth.loginWithGoogle()" class="auth-btn mt-2">-->
<!--		<span class="auth-btn-icon"><i class="fa-brands fa-google"></i></span>-->
<!--		<span class="auth-btn-name">Authenticate Patient</span>-->
<!--	</button>-->

<!--</div>-->
<!--<div class="video-layer">-->
<!--	<video src="/videos/bg-02.mov" autoplay class="background-video" loop muted playsinline></video>-->
<!--</div>-->

<app-auth-wrapper>
	<div class="content-wrapper">
		<!--		<input type="password" [(ngModel)]="passphrase" class="auth-input" placeholder="ENTER YOUR PASSPHRASE"/>-->
		<!--			<input [(ngModel)]="svcAuth.clinicianEmail" class="auth-input" placeholder="Email" type="text"/>-->
		<!--			<input [(ngModel)]="svcAuth.clinicianPword" class="auth-input" placeholder="Password" type="password"/>-->

		<div (click)="svcAuth.loginWithGoogle()" class="auth-btn">
			<div class="auth-btn-icon"><i class="fa-brands fa-google"></i></div>
			<div class="auth-btn-text">Authenticate Patient</div>
		</div>
	</div>
</app-auth-wrapper>